import makeStyles from '@mui/styles/makeStyles'
import { borderRadius } from '@mui/system'

export const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  mt: {
    marginTop: '10px',
  },

  appBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#0A688D',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: '0 0 0 0 #fff',
  },
  indicator: {
    backgroundColor: 'white',
    borderTop: '1px solid #333',
  },
  titleBar: {
    flex: 1,
    flexDirection: 'row',
    alignContent: 'space-between',
  },

  btn: {
    backgroundColor: '#0A688D',
    color: '#fff !important',
    padding: '6px 32px !important',
    borderRadius: '8px',
    borderColor: '#fff',
    marginLeft: '18px',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  diagnoseBtn: {
    backgroundColor: '#0A688D',
    color: '#fff !important',
    borderColor: '#fff',
    marginLeft: '5px',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  dontReportBtn: {
    backgroundColor: '#C41E3A',
    color: '#fff !important',
    borderColor: '#fff',
    marginLeft: '5px',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#C41E3A',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#C41E3A',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  notDiagnosedBtn: {
    backgroundColor: 'orange',
    color: '#fff !important',
    borderColor: '#fff',
    marginLeft: '2px',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: 'orange',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: 'orange',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  previewReportButton: {
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    color: '#0a688d',
    padding: '6px 32px !important',
    borderRadius: '8px',
    borderColor: '#0a688d',
    marginLeft: '18px',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#ffffff',
      color: '#0a688d',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#ffffff',
      color: '#0a688d',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  amendBtn: {
    width: '300px',
  },
  releaseBtn: {
    width: '150px',
  },
  disableEdit: {
    color: 'grey',
    float: 'right',
    width: '4%',
    cursor: 'pointer',
  },
  enableEdit: {
    color: '#0A688D',
    float: 'right',
    width: '4%',
    cursor: 'pointer',
    '&:hover': {
      color: '#0A688D',
    },
  },

  disableBtn: {
    backgroundColor: '#797979',
    color: '#fff !important',
    borderRadius: '8px',
    borderColor: '#fff',
    marginLeft: '5px',
    padding: '5px',
    width: '140px',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#797979',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#797979',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },

  checkbox: {
    marginLeft: '20px',
  },

  disabledCheckbox: {
    marginLeft: '20px',
    disabled: true,
    pointerEvents: 'none',
  },

  disabledCancelBtn: {
    backgroundColor: '#797979',
    color: '#fff !important',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
    zIndex: '999',
    marginLeft: '10px',
    '&:hover': {
      backgroundColor: '#797979',
    },
  },

  disableSaveBtn: {
    width: '144px',
    height: '40px',
    padding: '2px 2px 2px 2px',
    borderRadius: '5px',
    marginLeft: '10px',
    backgroundColor: '#797979',
    color: '#fff !important',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
    zIndex: '999',
    '&:hover': {
      backgroundColor: '#797979',
    },
    float: 'right',
  },

  mb: {
    marginBottom: '10px',
  },
  avatar: {
    color: '#0a688d',
    size: 18,
  },
  link: {
    textDecoration: 'none',
    color: '#0A688D',
    fontSize: '14px',
    marginTop: '10px',
  },
  dropdownTitle: {
    backgroundColor: '#0A688D',
    color: '#FFF',
    height: '40px',
    marginTop: '-4px',
  },
  notDiagnoseddropdownTitle: {
    backgroundColor: 'orange',
    color: '#FFF',
    height: '40px',
    marginTop: '-4px',
  },
  dontReportTitle: {
    backgroundColor: '#C41E3A',
    color: '#FFF',
    height: '40px',
    marginTop: '-4px',
  },
  dropdownLabel: {
    fontSize: '16px',
    padding: '10px',
  },
  span: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  summaryBox: {
    width: '100%',
    height: '100%',
    backgroundColor: '#f2f2f2',
    overflowX: 'hidden',
    fontSize: '14px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  },
  patientInfoHeader: {
    marginTop: '5px',
    paddingBottom: '10px',
    width: '100%',
    color: 'black',
    borderRadius: '10px',
    backgroundColor: 'rgba(146, 187, 204, 0.55)',
  },
  diagnosisTitle: {
    backgroundColor: 'rgba(255, 255, 255, 0)',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    color: '#d18a00',
    textAlign: 'left',
    marginLeft: '8px',
    fontSize: '20px',
  },
  patientInformation: {
    height: '98%',
    textAlign: 'left',
    lineHeight: 'normal',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    color: '#242424',
    marginTop: '0px',
    marginBottom: '10px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    boxShadow: '3px 0px 6px 0px rgba(0, 0, 0, 0.13)',
  },
  patientDob: {
    marginTop: '20px',
    width: '69px',
    height: '48px',
    fontWeight: '50',
    textAlign: 'right',
    lineHeight: '24px',
    fontSize: '14px',
    marginLeft: '21px',
    float: 'left',
    cursor: 'pointer',
  },
  patientDobDetails: {
    marginLeft: '97px',
    fontWeight: '300',
    lineHeight: '1.5rem',
    height: '48px',
    fontSize: '18px',
    marginTop: '20px',
    cursor: 'pointer',
  },
  caseDetails: {
    marginTop: '2px',
    padding: '2px 2px 33px 7px',
    //borderBottom: '1px solid #797979',
    marginLeft: '24px',
    lineHeight: '1.5rem',
    width: '324px',
    height: '145px',
  },
  caseLabels: {
    width: '115px',
    float: 'left',
  },
  caseValues: {
    width: '200px',
    float: 'right',
  },
  locationName: {
    height: '42px',
    fontWeight: '600',
    padding: '7px 7px 7px 15px',
    float: 'left',
    width: '307px',
    color: '#0A688D',
  },
  sampleLocation: {
    height: '600px',
    padding: '7px 7px 7px 15px',
    float: 'left',
    fontWeight: 600,
    color: '#797979',
  },
  slideDetailsTitle: {
    height: '42px',
    fontWeight: '600',
    padding: '7px 7px 7px 15px',
    color: '#fff',
    backgroundColor: '#0d688d',
  },
  reportBuilderTitle: {
    height: '42px',
    fontWeight: 'bolder',
    padding: '7px 7px 7px 15px',
    color: '#fff',
    backgroundColor: '#0d688d',
  },
  selectionsMadeTitle: {
    height: '42px',
    fontWeight: 'bolder',
    padding: '7px 7px 7px 15px',
    color: '#fff',
    backgroundColor: '#0d688d',
  },
  sampleLocations: {
    boxSizing: 'border-box',
    borderRadius: '3px',
    boxShadow: '0px 0px 7px 0px rgba(0, 0, 0, 0.19)',
    paddingBottom: '5px',
  },
  sampleLocationsTitle: {
    height: '42px',
    fontWeight: 'bolder',
    padding: '12px 7px 7px 15px',
    color: '#fff',
    backgroundColor: '#0d688d',
  },
  caseDetailsTitle: {
    boxSizing: 'border-box',
    padding: '12px 7px 7px 15px',
    height: '42px',
    fontWeight: 'bolder',
    color: '#fff',
    backgroundColor: '#0d688d',
  },
  reportSectionTitle: {
    boxSizing: 'border-box',
    padding: '12px 7px 7px 15px',
    height: '42px',
    fontWeight: 'bolder',
    color: '#fff',
    backgroundColor: '#0d688d',
  },
  slideItem: {
    flexGrow: 1,
    backgroundColor: '#fff',
  },
  slideImage: {
    padding: '2px',
    height: '75px',
    width: '140px',
    color: 'rgba(146, 187, 204, 0.55)',
  },
  reportInformation: {
    width: '87%',
    height: '98%',
    textAlign: 'left',
    lineHeight: 'normal',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    color: '#242424',
    marginTop: '0px',
    marginBottom: '10px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    boxShadow: '3px 0px 6px 0px rgba(0, 0, 0, 0.13)',
  },
  statusMessage: {
    color: '#0A688D',
  },
  statusMessageCorrect: {
    color: '#d18a00',
  },
  cancelledStatusMessage: {
    color: '#C41E3A',
  },
  statusMessageConsult: {
    color: '#f2c14e',
  },
  reportTitle: {
    marginLeft: '18px',
  },
  divider: {
    paddingBottom: '16px',
  },
  reportDetails: {
    marginTop: '22px',
    lineHeight: '3rem',
    marginLeft: '20px',
  },
  reportLink: {
    textDecoration: 'underline',
    color: '#0a688d',
    textAlign: 'left',
    float: 'left',
    cursor: 'pointer',
  },
  reportDate: {
    color: 'rgba(0, 0, 0, 0.99)',
  },
  TextBox: {
    width: '95%',
    marginBottom: '1rem',
  },
  section: {
    // marginLeft: '4.5%',
    border: '1px solid rgba(0, 0, 0, 0.19)',
  },
  outerSection: {
    marginLeft: '3.3%',
    border: '2px solid #0A688D',
    flexGrow: 1,
    overflowX: 'hidden',
    marginBottom: '5px',
  },
  outerSelectionSection: {
    marginLeft: '5%',
    border: '2px solid #0A688D',
    flexGrow: 1,
    // height: '1040px',
    overflowX: 'hidden',
    marginBottom: '5px',
  },
  slideDetails: {
    borderRadius: '3px',
    height: '100%',
    lineHeight: 'normal',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    marginTop: '0px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    boxShadow: '3px 0px 6px 0px rgba(0, 0, 0, 0.13)',
  },
  slidesWrapper: {
    flexGrow: 1,
    height: '100%',
    overflowX: 'hidden',
  },
  sectionProcedureTitle: {
    fontWeight: '600',
    marginLeft: '12px',
    padding: '5px',
    color: '#0A688D',
  },
  reportBuilderWrapper: {
    flexGrow: 1,
    height: '940px',
    overflowX: 'hidden',
    marginLeft: '24px',
  },
  sectionTitle: {
    fontWeight: '600',
    marginLeft: '12px',
  },
  reportBuilder: {
    flexGrow: 1,
    height: '100%',
    borderRadius: '3px',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 7px 0px rgba(0, 0, 0, 0.19)',
    marginTop: '0px',
  },
  selectionsMade: {
    flexGrow: 1,
    height: '1040px',
    width: '92%',
    borderRadius: '3px',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 7px 0px rgba(0, 0, 0, 0.19)',
    marginTop: '0px',
    backgroundColor: '#ffffff',
  },
  previewButton: {
    width: '140px',
    height: '29px',
    padding: '2px 2px 2px 2px',
    borderRadius: '5px',
    border: '1px solid #0a688d',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    color: '#0a688d',
    textAlign: 'center',
    float: 'right',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ffffff',
      color: '#0a688d',
    },
  },
  diagnosedStainName: {
    textAlign: 'left',
    textDecoration: 'underline',
    color: '#0A688D',
    cursor: 'pointer',
    fontWeight: 'bolder',
  },
  notDiagnosedStainName: {
    textAlign: 'left',
    textDecoration: 'underline',
    color: 'orange',
    cursor: 'pointer',
    fontWeight: 'bolder',
  },
  disabledStainName: {
    textAlign: 'left',
    color: '#797979',
    fontWeight: 'bolder',
    pointerEvents: 'none',
  },
  disabledReportLink: {
    height: '30px',
    color: '#797979',
    padding: '0px 7px 7px 7px',
    marginLeft: '12px',
    float: 'right',
    pointerEvents: 'none',
  },
  reportIcon: {
    color: '#0d688d',
    float: 'left',
    height: '20px',
  },
  disabledReportIcon: {
    color: '#797979',
    float: 'left',
    height: '20px',
    pointerEvents: 'none',
  },
  stainDescription: {
    textAlign: 'left',
    color: 'orange',
  },
  viewReport: {
    textDecoration: 'underline',
    color: '#0A688D',
    height: '30px',
    cursor: 'pointer',
    padding: '0px 7px 7px 7px',
    marginLeft: '12px',
    float: 'right',
  },
  slideGrid: {
    marginTop: '0px',
  },
  slideDetailsContainer: {
    marginLeft: '20px',
    marginRight: '20px',
  },
  leftSlideDetails: {
    float: 'left',
    margin: '22px 0px 0px 15px',
  },
  rightSlideDetails: {
    width: '180px',
    float: 'right',
    margin: '8px 0px 0px 15px',
  },
  stainDetailType: {
    color: '#333333',
    fontSize: '14px',
  },
  stainDetailDescription: {
    color: '#C41E3A',
    fontSize: '14px',
    fontWeight: 'bolder',
  },
  stainNameLeft: {
    color: '#0A688D',
    fontWeight: 'bolder',
    fontSize: '14px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  disabledLink: {
    color: '#797979',
    fontWeight: 'bolder',
    fontSize: '14px',
    pointerEvents: 'none',
  },
  notDiagnosedStainNameLeft: {
    color: 'orange',
    fontWeight: 'bolder',
    fontSize: '14px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  stainDescriptionLeft: {
    color: '#797979',
    fontSize: '14px',
    marginLeft: '20px',
  },
  selectionContainer: {
    overflowY: 'scroll',
    height: '935px',
    padding: '0px',
  },
  diagnosisContainer: {
    overflowX: 'hidden',
    padding: '2px 2px 2px 2px',
  },
  commentsContainer: {
    overflowX: 'hidden',
    padding: '2px 2px 2px 2px',
    marginLeft: '15px',
  },
  containerTitle: {
    paddingLeft: '15px',
    fontWeight: '700',
    backgroundColor: 'rgba(146, 187, 204, 0.55)',
  },
  releaseButton: {
    width: '144px',
    height: '40px',
    padding: '2px 2px 2px 2px',
    borderRadius: '5px',
    border: '1px solid #0a688d',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    color: '#0a688d',
    textAlign: 'center',
    float: 'right',
    marginLeft: '10px',
  },
  saveButton: {
    width: '144px',
    height: '40px',
    padding: '2px 2px 2px 2px',
    borderRadius: '5px',
    backgroundColor: '#0a688d',
    boxSizing: 'border-box',
    color: '#ffffff',
    textAlign: 'center',
    marginLeft: '10px',
    float: 'right',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  buttonActions: {
    borderTop: '1px solid #d3d3d3',
    marginRight: '0px',
    paddingTop: '8px',
  },
  diagnosisCommentsContainer: {
    // backgroundColor: '#fbfdcd',
    marginLeft: '-4%',
  },
  generalCommentsContainer: {
    // backgroundColor: 'rgb(146 179 204 / 14%)',
    marginLeft: '-4%',
  },
  selectedBlock: {
    borderRadius: '5px',
    borderColor: '#797979',
    wordWrap: 'break-word',
    backgroundColor: 'rgb(146 179 204 / 14%)',
    width: '83%',
    display: 'block',
    padding: '2px 2px 2px 2px',
    border: '1px solid',
    float: 'left',
    boxShadow: '3px 0px 6px 0px rgb(0 0 0 / 13%)',
    margin: '2px',
    '&:focus-visible': {
      outline: '0px !important',
      borderRadius: '5px',
      borderColor: '#0A688D',
    },
  },
  editSelectedBlock: {
    borderRadius: '5px',
    borderColor: '#0A688D',
    backgroundColor: 'rgb(146 179 204 / 14%)',
    width: '83%',
    display: 'block',
    padding: '2px 2px 2px 2px',
    border: '1px solid',
    float: 'left',
    boxShadow: '3px 0px 6px 0px rgb(0 0 0 / 13%)',
    margin: '2px',
  },
  removeBtn: {
    color: 'grey',
    float: 'right',
    width: '4%',
    cursor: 'pointer',
  },
  disabledIcon: {
    color: 'grey',
    opacity: 0.5,
    float: 'right',
    width: '4%',
    disabled: true,
    pointerEvents: 'none',
  },
  customizedMenu: {
    float: 'right',
  },
  location: {
    margin: '14px',
  },
  legendTitle: {
    color: '#0A688D',
    fontWeight: 'bold',
  },
  optionTitle: {
    float: 'left',
    width: '170px',
    textAlign: 'left',
    marginTop: '16px',
  },
  optionValue: {
    float: 'right',
    width: '100px',
  },
  clinicalInfo: {
    marginLeft: '16px',
    overflowY: 'scroll',
    height: '450px',
    width: '92%',
    marginBottom: '15px',
  },
  reportHistory: {
    width: '95%',
    height: '390px',
    marginLeft: '16px',
    overflowY: 'scroll',
  },
  grossDescription: {
    float: 'left',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#0d688d',
  },
  locationTitle: {
    width: '39%',
    float: 'left',
    marginLeft: '7px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  dialogTitle: {
    backgroundColor: '#0A688D',
    color: '#FFF',
  },
  buttonMargin: {
    marginLeft: '10px',
  },
  diagnosisFieldset: {
    borderStyle: 'solid',
    borderRadius: '5px',
    width: '95%',
  },
  discardDialogHeight: {
    height: '180px',
  },
  resetDialogHeight: {
    height: '215px',
  },
  discardDialogContent: {
    display: 'flex',
    justifyContent: 'left',
    marginTop: '20px',
  },
  dialogHeight: {
    overflowY: 'hidden',
    height: '100vh',
  },
  previewDialogHeight: {
    height: '100%',
    overflowY: 'hidden',
    width: '100%',
  },
  amendDialogHeight: {
    height: '100%',
    overflowY: 'hidden',
    width: '100%',
  },
  loadingIndicator: {
    marginTop: '15%',
    marginLeft: '48%',
    color: '#0a688d',
    position: 'absolute',
  },
  slidesLoadingIndicator: {
    marginTop: '80%',
    marginLeft: '42%',
    color: '#0a688d',
  },
  excludeIcon: {
    verticalAlign: 'bottom',
    color: '#C41E3A',
    fontSize: 'large',
    marginLeft: '15%',
  },
  includeIcon: {
    verticalAlign: 'bottom',
    color: '#0A688D',
    fontSize: 'large',
    marginLeft: '15%',
  },
  notDiagnosedIcon: {
    verticalAlign: 'bottom',
    color: 'orange',
    fontSize: 'large',
    marginLeft: '15%',
  },
  disabledDiagnosedIcon: {
    verticalAlign: 'bottom',
    color: '#797979',
    fontSize: 'large',
    marginLeft: '15%',
  },
  chipSpacing: {
    marginRight: '5px',
  },
  container: {
    flex: 1,
    display: 'block',
  },
  disabledRefreshIcon: {
    color: '#797979',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
  },
  refreshIcon: {
    color: '#fff',
    cursor: 'pointer',
  },
  calloutComment: {
    color: 'red',
    margin: 0,
  },
  generalComment: {
    color: 'black',
    margin: 0,
  },
  filterButton: {
    backgroundColor: '#0A688D',
    color: '#fff !important',
    borderRadius: '5px',
    borderColor: '#fff',
    marginLeft: '5px',
    marginRight: '2px',
    padding: '5px',
    float: 'left',
    minWidth: '40px',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    dragHandle: {
      cursor: 'grab',
    },
    dragHandleGrabbing: {
      cursor: 'grabbing',
    },
  },
  sliderColor: {
    color: '#0A688D',
  },
})
